import { addMilliseconds, format, isAfter, parseISO } from 'date-fns';

import { checkHasPermissions, isAdmin } from '../../utils';

import { CATEGORIES_LIST } from './constants';

import permissions from '../../permissions';

export const calculateDuration = (startISOString, endISOString) => {
  const startTime = new Date(startISOString);
  const endTime = new Date(endISOString);

  const durationInMilliseconds = endTime - startTime;

  return durationInMilliseconds;
};

export const getFormattedEndTime = (dateString, duration) => {
  const date = new Date(dateString);
  let result;

  if (duration && date) {
    result = new Date(date.getTime() + duration)?.toISOString();
  }

  return result;
};

export const getISOStringFromDateAndTime = (dateString, timeString) => {
  let dateObj;
  if (dateString.includes('T')) {
    // dateString is in format UTC
    dateObj = new Date(dateString);
  } else {
    // dateString is in format YYYY-MM-DD
    dateObj = new Date(Date.parse(dateString));
  }
  const dateTimeString = `${dateObj
    .toISOString()
    .substring(0, 10)}T${timeString}`;
  const isoString = new Date(dateTimeString)?.toISOString();

  return isoString;
};

export const formatDateTimeRange = (isoDate, duration) => {
  const startTime = new Date(isoDate);
  const endTime = addMilliseconds(startTime, duration);

  const formattedStartDate = format(startTime, 'M/d, h:mma');
  const formattedEndDate = format(endTime, 'h:mma');

  return `${formattedStartDate} - ${formattedEndDate}`;
};

export const formatDateTime = (isoDate) => {
  if (isoDate) {
    const date = new Date(isoDate);
    return format(date, "M/d/yy 'at' h:mm a");
  }
  return '';
};

export const findCategoryLabel = (value) => {
  const item = CATEGORIES_LIST.find((item) => item.value === value);
  return item.label;
};

export const parseCategoriesList = (list) =>
  list.map((category) => findCategoryLabel(category)).join(', ');

export const getDayOfWeek = (isoDate) => {
  if (isoDate) {
    const date = parseISO(isoDate);
    const dayOfWeek = format(date, 'EEEE');
    return dayOfWeek;
  }
  return '';
};

export const isDateValid = (isoDate, duration) => {
  const currentDate = new Date();
  const targetDate = parseISO(isoDate);
  const endDate = new Date(targetDate.getTime() + duration);

  return isAfter(endDate, currentDate);
};

export const composeGuests = (data) => {
  const results = [];

  data?.results?.forEach((item) => {
    const { id, attendee, guests } = item;

    results.push({
      id,
      ...attendee,
    });

    guests.forEach((guest) => {
      results.push({
        id: guest.id,
        fullName: guest.attendeeName,
      });
    });
  });

  return {
    ...data,
    results,
  };
};

export const isFile = (obj) =>
  obj !== null && typeof obj === 'object' && obj.constructor === File;

export const formatRsvpsForFilter = (data = []) =>
  data?.map((item) => ({
    value: item?.id,
    label: item?.attendee?.fullName,
  }));

export const formatResidentsForFilter = (data = []) =>
  data?.map((item) => ({
    value: item?.id,
    label: `${item?.firstName} ${item?.lastName}`,
  }));

export const checkCanUserEditEvent = (
  currentUserId,
  creatorId,
  startsAt,
  duration,
) => {
  const hasPermissions = checkHasPermissions(permissions.edit_social_event);
  const isPastEvent = isDateValid(startsAt, duration);

  if (isPastEvent)
    return isAdmin() || hasPermissions || currentUserId === creatorId;
  return false;
};
